<template>
  <div class="page-container content-430">
    <div class="header-wrapper-430">
      <!-- 搜索模块 -->
      <SearchBlock
        ref="searchBlock"
        :normal-class-index="true"
        @getSearchValue="handleGetSearch"
      ></SearchBlock>
      <div class="table-title-special-430 flex justify-content_end">
        <!-- 头部搜索框 end  -->
        <div class="ex-btn">
          <Button
            type="primary"
            class="search-430"
            @click="handleEdit"
          >修改考勤</Button>
          <Button
            type="primary"
            class="search-430"
            @click="handleExport"
          >下载</Button>
        </div>
      </div>
    </div>
    <div class="table table-box">
      <Table
        ref="recordTable"
        border
        :max-height="tableHeight - 40"
        :loading="loading"
        :disabled-hover="true"
        :columns="tableColumnShow"
        :data="tableData"
      ></Table>
      <div class="page-wrap">
        <Page
          :total="pageInfo.total"
          show-total
          show-sizer
          show-elevator
          :page-size-opts="pageSizeOpts"
          :current="pageInfo.pageNum"
          @on-change="getNewPage"
          @on-page-size-change="handlePageSize"
        ></Page>
      </div>
    </div>
    <!-- 下载的进度弹窗 -->
    <Modal
      v-model="percentModalShow"
      title="正在导出"
      :mask-closable="false"
      @on-cancel="handleCancelDownLoad"
    >
      <Progress :percent="downLoadPersent" :stroke-width="5"></Progress>
      正在导出表格，请给我一些时间，请不要关闭当前页面！
      <div slot="footer">
        <Button @click="handleCancelDownLoad">取消</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from 'axios';
import { mapState, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import { getDaysInMonth, getWeekText } from '@/utils/utils';
import eduCenter from '@/request/eduCenter/index.js';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import {
  signStatusList,
  changeDictionaries,
  hasRefundTallyStsList
} from '@/utils/dictionary.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
export default {
  name: 'StudentAttanceNormalClassIndex',
  components: {
    SearchBlock
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      portOrg: -1,
      schoolId: '',
      tableColumn: [
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 100,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column table-left-column-font'
        },
        {
          title: '年级班级',
          key: 'gradeAndClass',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
          className: 'table-left-column'
        }
      ],
      tableColumnShow: [],
      tableData: [],
      loading: false,
      pageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      pageSizeOpts: [10, 20, 50, 100],
      dayObj: {},
      searchKey: ['schoolId', 'classroomName', 'gradeId', 'classId', 'studentName', 'yearCode', 'termCode', 'classType'],
      searchParams: null, // 拿到的搜索参数
      percentModalShow: false,
      downLoadPersent: 0, // 下载进度调
      percentInterVal: null,
      source: null,
      sourceFirst: null,
      downloadUrl: '',
      downloadToken: '',
      cancelFirst: false
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState'])
  },

  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.$nextTick(() => {
      if (this.portOrg === 2) {
        this.schoolId = this.userInfo.orgId;
      } else {
        // this.schoolId = localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
        this.schoolId = this.schoolIdForState ? this.schoolIdForState : '';
      }
      this.$refs.searchBlock.getSchoolId(this.schoolId);
    });
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      this.schoolId = id;
      this.$refs.searchBlock.getSchoolId(this.schoolId);
    });
    // this.getNowDayStr();
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.schoolId = id;
      this.$refs.searchBlock.getSchoolId(this.schoolId);
    });
    this.getStudentAttendance();
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('StudentAttanceNormalClassIndex');
    next();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    handleGetSearch(searchParams) {
      this.getMonthList(searchParams.selectMonth);
      const obj = {};
      Object.keys(searchParams).forEach(item => {
        if (this.searchKey.includes(item) && searchParams[item] !== null && searchParams[item] !== undefined) {
          obj[item] = searchParams[item];
        }
      });
      obj.month = `${searchParams.selectMonth}-01 00:00:00`;
      this.searchParams = { ...obj };
      this.pageInfo.pageNum = 1;
      this.getStudentAttendance();
    },
    // 获取学生考勤记录
    async getStudentAttendance() {
      const params = {
        ...this.searchParams,
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      this.loading = true;
      try {
        const res = await eduCenter.getClassSignsPerMonthPageApi(params);
        if (res.status === 200) {
          this.tableData = res.message.list.map(item => {
            const dayObjCopy = JSON.parse(JSON.stringify(this.dayObj));
            if (item.signInfoList) {
              item.signInfoList.forEach(item => {
                dayObjCopy[item.dateStr].push(item);
              });
            }
            return {
              studentName: item.studentName,
              gradeAndClass: `${item.gradeName}${item.className}`,
              ...dayObjCopy
            };
          });
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },
    getMonthList(monthStr) {
      this.dayObj = {};
      const list = getDaysInMonth(monthStr.substring(0, 4), monthStr.substring(5)).map(item => {
        this.dayObj[`${item.substring(5)}`] = [];
        return {
          title: item.substring(5),
          key: item.substring(5),
          minWidth: 120,
          align: 'center',
          className: 'table-status-column cursor-pointer',
          renderHeader: (h, { column, index }) => {
            return h(
              'div',
              [
                h('div', [item.substring(5)]),
                h('div', [getWeekText(item)])
              ]
            );
          },
          render: (h, { row, column, index }) => {
            return h(
              'div', [
                row[item.substring(5)] ? row[item.substring(5)].length === 0
                  ? h('div', {
                    style: {
                      color: '#999'
                    }
                  }, ['当日无课'])
                  : row[item.substring(5)].map(x => {
                    return h(
                      'div', {
                        class: {
                          'class-box': true,
                          'hasrefund-box': hasRefundTallyStsList.includes(x.tallySts) || x.tallySts === 8
                        }
                      }, [
                        h('div', {
                          class: {
                            'classroom-div': true
                          }
                        }, [x.classroomName]),
                        h('span', {
                          class: {
                            'signstatue-span': true,
                            'signstatue-nosign': (!hasRefundTallyStsList.includes(x.tallySts)) && (x.signStatue === 0 || x.signStatue === 1 || x.signStatue === 5 || x.signStatue === 6),
                            // 请假的，紫色字体
                            'signstatue-leave': x.signStatue === 4 || ((!hasRefundTallyStsList.includes(x.tallySts)) && x.signStatue === 5)
                          }
                        }, [hasRefundTallyStsList.includes(x.tallySts) && x.signStatue !== 4 ? '已退款' : changeDictionaries(signStatusList)[x.signStatue],
                          h('span', { style: { color: '#333' }}, [(!hasRefundTallyStsList.includes(x.tallySts)) && x.refundOrderId && (+x.refundOrderId) ? '(待退款)' : '']),
                          h('span', { style: { color: '#333' }}, [(x.tallySts === 1 || x.tallySts === 3 || x.tallySts === 4) ? '(已结算)' : '']),
                          h('span', { style: { color: '#333' }}, [x.leaveWaitApprove === 'true' ? '(请假待审批)' : x.signStatue === 4 && hasRefundTallyStsList.includes(x.tallySts) ? '(已退款)' : x.signStatue === 4 && x.tallySts === 8 ? '(可退款)' : ''])
                        ])
                      ]
                    );
                  }) : ''
              ]
            );
          }
        };
      });
      this.tableColumnShow = this.tableColumn.concat(list);
    },
    getNewPage(page) {
      this.tableData = [];
      this.pageInfo.pageNum = page;
      this.getStudentAttendance();
    },
    // 页条数改变
    handlePageSize(pageSize) {
      this.tableData = [];
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getStudentAttendance();
    },
    // 取消导出
    handleCancelDownLoad() {
      if (this.source) {
        this.source.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        this.percentModalShow = false;
        // this.uploadPersent = 0;
        // this.canUploadFile = true;
        // this.modalShow = false;
        // this.uploadType === '';
      }
      if (this.sourceFirst) {
        this.sourceFirst.cancel('取消导出'); // 这里传递的什么字符串，在上面的rej.message值就是什么
        this.cancelFirst = true;
        this.percentModalShow = false;
      }
    },

    async handleExport() {
      this.downLoadPersent = 0;
      this.percentModalShow = true;
      const taskId = await this.getDownloadTaskId();
      this.getTasksStatus(taskId);
    },
    // 获取下载任务id
    async getDownloadTaskId() {
      return new Promise(async(resolve, reject) => {
        const params = { ...this.searchParams, pageNum: 1, pageSize: 100000 };
        try {
          this.cancelFirst = false;
          this.sourceFirst = axios.CancelToken.source();
          const res = await eduCenter.exportClassSignsPerMonthApi(params, this.sourceFirst.token);
          this.sourceFirst = null;
          if (res.status === 200) {
            resolve(res.message);
          } else {
            this.$Message.error('下载失败');
            this.percentModalShow = false;
            reject(false);
          }
        } catch (err) {
          if (!this.cancelFirst) {
            console.log(err);
            this.$Message.error('下载失败');
            this.percentModalShow = false;
          }
          reject(false);
        }
      });
    },
    // 获取任务的进度
    async getTasksStatus(taskId) {
      this.downLoadPersent += 20;
      const returnThreshold = this.downLoadPersent;
      const params = {
        batchIds: [taskId], // 任务id
        returnThreshold: returnThreshold // 默认全部完成返回，百分比
      };
      this.source = axios.CancelToken.source();
      const res = await courseSchedulCenter.getTaskProgressApi(params, this.source.token);
      this.source = null;
      if (res.status === 200) {
        const loadingIdsArray = res.message.filter(item => {
          return item.prcSts === 2 || item.prcSts === 0;
        });
        const failArray = res.message.filter(item => {
          return item.prcSts === 3;
        });
        if (loadingIdsArray.length > 0) {
          this.getTasksStatus(taskId);
        } else if (failArray.length === 0) {
          this.downLoadPersent = 100;
          const fileId = res.message[0].msg;
          this.getDownloadInfo(fileId);
        } else {
          this.$Message.error('下载失败');
          this.percentModalShow = false;
        }
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      const params = {
        fileId: [fileId],
        type: 2
      };
      const res = await cateringAdmin.getDownloadtoken(params);
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
        this.downloadToken = res.message.token;
      }
    },
    // 点击下载文件
    async getDownloadInfo(fileId) {
      const downloadElement = document.createElement('a');
      await this.getDownloadtoken(fileId);
      const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      // downloadElement.download = `111_${this.searchParams.month}学生考勤（行政班）汇总.xlsx`; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      this.percentModalShow = false;
    },
    // 编辑
    handleEdit() {
      this.$router.push({
        name: 'eduCenter_studentAttance_NormalClassEdit'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-table td.table-status-column {
  width: 100%;
  height: 100%;
  padding: 0;
  .ivu-table-cell {
    width: 100%;
    height: 100%;
    padding: 0;
    .class-box {
      padding: 12px 4px;
      .classroom-div {
        font-size: 14px;
        line-height: 20px;
      }
      .signstatue-span {
        font-size: 12px;
        line-height: 20px;
      }
      .signstatue-nosign {
        color: red;
      }
      .signstatue-leave {
        color: blue;
      }
      .signstatue-absence {
        color: #63a103;
      }
    }
    .hasrefund-box {
      background: #f8f8f9;
      opacity: 0.8;
    }
    .class-box + .class-box {
      border-top: 1px solid #e9ebed;
    }
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
</style>
